// 格式化金额显示
export const formatCreditAmount = (creditAmount: number | string, ratio?: number): string => {
  // eslint-disable-next-line no-nested-ternary
  const fixedRatio = typeof ratio === 'number'
    ? ratio : (String(Number(creditAmount)).includes('.') ? 2 : 0);

  return Number(creditAmount)
    .toFixed(fixedRatio)
    .replace(/(\d)(?=(?:\d{3})+($|\.))/g, '$1,');
};

// 目标数组中是否存在近似字符串，即存在包含关系
export const isContain = (arr: string[], p: string): boolean => {
  for (let i = 0; i < arr.length; i += 1) {
    if (arr[i].includes(p) || p.includes(arr[i])) {
      return true;
    }
  }

  return false;
};
